// Textos do bloco fixo no topo de cada card, por etapa do processo:
// o que está acontecendo, o que depende do cliente e quanto costuma demorar.
// Mesma tabela usada nos e-mails e no WhatsApp.
export const dataEtapas = {
  documentacao: {
    acontecendo: "Aguardamos os documentos da lista.",
    depende:
      "Reunir, apostilar (quando indicado) e enviar pelos Correios com o PT no envelope.",
    demora: "Depende de você. Confirmamos em até 72h úteis após chegar.",
  },
  analise: {
    acontecendo: "Nossa equipe confere cada documento.",
    depende: "Nada. Se faltar algo, avisamos.",
    demora: "Até 10 dias úteis.",
  },
  obstaculo: {
    acontecendo: "Encontramos um problema que impede o envio.",
    depende:
      "Se precisarmos de algo seu, avisamos. Fale com a gente se tiver dúvida.",
    demora: "Depende da solução. Avisamos quando resolver.",
  },
  apostilamento: {
    acontecendo:
      "Os documentos aprovados estão sendo apostilados (ou já vieram apostilados).",
    depende: "Nada.",
    demora: "Até 15 dias.",
  },
  despacho: {
    acontecendo: "Montamos o processo para envio a Portugal.",
    depende: "Nada.",
    demora: "Até 10 dias.",
  },
  // Plano 2026: o cliente paga a taxa da conservatória.
  despacho2026: {
    acontecendo: "Montamos o processo para envio a Portugal.",
    depende: "Pagar a taxa da conservatória quando enviarmos os dados.",
    demora: "Até 10 dias após a taxa.",
  },
  portugal: {
    acontecendo: "O pedido está na conservatória.",
    depende: "Nada. Com senha, você pode consultar no site da Justiça.",
    demora: "Previsão no card; informação oficial do IRN quando houver.",
  },
  exigencia: {
    acontecendo: "A conservatória pediu um complemento.",
    depende: "Só se precisarmos de documento seu; avisamos.",
    demora: "Depende da conservatória. Quando houver previsão, ela aparece no card.",
  },
  concluido: {
    acontecendo: "A conservatória concluiu. O assento foi emitido.",
    depende:
      "Baixar o assento e, se quiser, pedir cartão de cidadão e passaporte.",
    demora: "—",
  },
};

// step.name -> chave em dataEtapas
export const etapaPorStep = {
  documentation: "documentacao",
  incomplete_documentation: "documentacao",
  complete_documentation: "analise",
  blocked: "obstaculo",
  blocked_post: "obstaculo",
  hague: "apostilamento",
  docs_ok: "apostilamento",
  unblocked: "apostilamento",
  post: "despacho",
  monitoring: "portugal",
  approved: "portugal",
  dispatched: "portugal",
  requirement: "exigencia",
};
